import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-one',
  templateUrl: './section-one.component.html',
  styleUrls: []
})
export class SectionOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
